import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { WORKSPACE_VERSION } from '@/api/workspace';
import type { SharedTab } from '@/domain/SharedTab.ts';

type GetSharedTabResponse = SharedTab | undefined;

export function getSharedTabQuery(builder: WebapiEndpointBuilder) {
  return builder.query<GetSharedTabResponse, string>({
    query: (tabId) => ({
      url: `/userdata/workspace/shared/${tabId}/${WORKSPACE_VERSION}`,
      method: 'GET',
    }),
    transformResponse: (response: SharedTab | {}) => {
      // do no handle tab shared from fx
      if ('version' in response && response.version === 'forex') {
        return response;
      }
      return undefined;
    },
  });
}
